<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
$(document).ready(function() {
    var currentUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    if (currentUrl === window.location.protocol + "//" + window.location.host+"/collections" || currentUrl === window.location.protocol + "//" + window.location.host+"/collections/") {
        window.location.href = window.location.protocol + "//" + window.location.host+"/";
    }
});

// Example JavaScript handler
document.querySelectorAll('.video-button').forEach(button => {
  button.addEventListener('click', function() {
    const type = this.dataset.type;
    const src = this.dataset.src;
    
    if (type === 'custom') {
      // Handle custom video (MP4/WebM/OGG)
      videoPlayer.innerHTML = `<video controls src="${src}"></video>`;
    } else {
      // Handle YouTube/Vimeo
      // Your existing platform-specific code
    }
  });
});

$(document).ready(function(){
  $('.menu-dropdown__column .site-nav.dropdown .site-nav-list .text').mouseover(function () {
      const text = $(this).text().toLowerCase().trim();
      const handle = text.replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
  
      const $img = $('.menu-dropdown .menu-dropdown__banner img');
      const originalSrc = $img.attr('srcset');
  
      console.log('Looking for images with handle:', handle);
      
      // Common image formats to try (ordered by preference)
      const formats = ['webp', 'jpg', 'jpeg', 'png', 'gif'];
      let foundImage = false;
      
      // Function to try each format using fetch (no console errors)
      async function tryFormats(formatIndex = 0) {
          if (formatIndex >= formats.length || foundImage) {
              if (!foundImage) {
                  console.log(`No image found for handle: ${handle}, keeping original`);
                  $img.attr('srcset', originalSrc);
              }
              return;
          }
          
          const format = formats[formatIndex];
          
          // Replace filename with handle + current format
          const newSrc = originalSrc.replace(/\/[^\/]+\.(webp|jpg|jpeg|png|gif|svg|bmp|tiff|avif)/i, 
              `/${handle}.${format}`);
          
          // Extract the first URL from srcset for testing
          const testUrl = newSrc.split(',')[0].trim().split(' ')[0];
          
          try {
              const response = await fetch(testUrl, { method: 'HEAD' });
              if (response.ok && !foundImage) {
                  foundImage = true;
                  console.log(`✓ Found image: ${handle}.${format}`);
                  $img.attr('srcset', newSrc);
                  return;
              }
          } catch (error) {
              // Silently continue to next format
          }
          
          // Try next format
          await tryFormats(formatIndex + 1);
      }
      
      // Start trying formats
      tryFormats();
  });
});
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
